export default "__VITE_ASSET__DsbzoY2V__"